module.exports = __webpack_public_path__ + "img/GA-2017.8f62f357.png";